<template>
  <footer>
    <ul :class="[$i18n.locale]">
      <li v-for="meta in $t('footer.meta')" :key="meta.name">
        <a v-if="meta.url" :href="meta.url" target="_blank">{{ meta.name }}</a>
        <router-link v-if="meta.route" :to="meta.route">{{ meta.name }}</router-link>
        <span>|</span>
      </li>
    </ul>
  </footer>
</template>

<script>
  export default {
    name: 'Footer',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
    },
  };
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  footer {
    @include max-width-constraints;
    height: 108px;
    display: flex;
    justify-content: center;
    align-items: center;

    ul {
      position: relative;
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      list-style-type: none;
      font-size: 1.4rem;

      @include screen-mobile {
        flex-wrap: wrap;
        max-width: 80vw;
      }

      li {
        a {
          color: inherit;
          font-size: inherit;
          text-decoration: none;
        }
        span {
          display: inline-block;
          margin: 0 8px;

          @include screen-mobile {
            margin: 0 4px;
          }
        }
        &:last-of-type span {
          display: none;
        }
      }
    }
  }
</style>
